// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jO8ciytiXAw6rMWPsYza{flex-direction:column;gap:24px;padding:40px 0 24px;display:flex}.sZfknusGQxEadB9JmJQ0,.b7StmY1Ggp3G4BYHgz6E{padding:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `jO8ciytiXAw6rMWPsYza`,
	"modalMode": `sZfknusGQxEadB9JmJQ0`,
	"grid": `b7StmY1Ggp3G4BYHgz6E`
};
export default ___CSS_LOADER_EXPORT___;
